import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsBlock() {
  const testimonials = [{
    name: 'Carlos M.',
    text: 'Pensé que sería otro PDF más, pero encontré información que nunca me habían explicado.'
  }, {
    name: 'Laura S.',
    text: 'Todo está explicado de forma clara y sencilla. Muy recomendable.'
  }, {
    name: 'Diego R.',
    text: 'El acceso fue inmediato y pude revisarlo desde mi celular sin problemas.'
  }, {
    name: 'Ana P.',
    text: 'Me ayudó a entender mejor mi situación y qué pasos puedo seguir.'
  }, {
    name: 'Martín G.',
    text: 'Excelente material educativo, muy completo y fácil de leer.'
  }, {
    name: 'Sofía L.',
    text: 'La información está muy bien organizada. Vale la pena.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-surface" data-id="element-326">
      <div className="max-w-6xl mx-auto" data-id="element-327">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-328">
          <h2 className="text-3xl md:text-4xl font-black text-slate-dark mb-4" data-id="element-329">
            Lo que dicen quienes ya accedieron
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-330">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-surface-gray p-6 rounded-2xl border border-gray-100 shadow-sm" data-id="element-331">
              <div className="flex items-center gap-3 mb-4" data-id="element-332">
                <div className="w-10 h-10 bg-brand-green/10 rounded-full flex items-center justify-center text-brand-green font-bold" data-id="element-333">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-334">
                  <div className="font-bold text-slate-dark" data-id="element-335">{t.name}</div>
                  <div className="flex gap-1 text-gold" data-id="element-336">
                    {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-337" />)}
                  </div>
                </div>
              </div>
              <p className="text-slate italic" data-id="element-338">"{t.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}